import axios from "axios";
import React, { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { ApiConnectionString } from "../../constants/ApiConntection";
import LoadingSpinner from "../../components/LoadingSpinner";

import ReCAPTCHA from "react-google-recaptcha";
import { useAuthContext } from "../../hooks/useAuthContext";
import "./VerifyEmail.css"
import { ProjectName } from "../../constants/ProjectName";


export default function VerifyEmail() {
  const { token } = useParams();
  const [pendingAccountExists, setPendingAccountExists] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [err, setErr] = useState("");
  const [emailVerified, setEmailVerified] = useState(false);
  const { dispatch } = useAuthContext();
  const [capVal, setCapVal] = useState(null);
  const navi = useNavigate();

  const normalizeErr = (data) => {
    if (!data) return "Bad Request";
    if (typeof data === "string") return data;
    if (data.message) return data.message;
    try {
      return JSON.stringify(data);
    } catch {
      return "Bad Request";
    }
  };

  const handleVerify = async () => {
    try {
      const response = await axios.post(
        `${ApiConnectionString}/api/user/${token}`
      );
      if (response.status === 200) {
        dispatch({ type: "LOGIN", payload: response.data });
        setEmailVerified(true);
      }
    } catch (error) {
      if (error.response && error.response.status === 400) {
        setErr(normalizeErr(error.response.data));
      } else {
        setErr("An unexpected error occurred.");
      }
    }
  };

  useEffect(() => {
    const getData = async () => {
      try {
        const response = await axios.get(
          `${ApiConnectionString}/api/peningAppUser/${token}`
        );
        if (response.status === 200) {
          setPendingAccountExists(response.data);
        }
      } catch (error) {
        if (error.response && error.response.status === 400) {
          setErr(normalizeErr(error.response.data));
        } else {
          setErr("An unexpected error occurred.");
        }
      } finally {
        setIsLoading(false);
      }
    };

    if (token) {
      getData();
    } else {
      setIsLoading(false);
    }
  }, [token]);

  if (isLoading) {
    return (
      <div>
        <LoadingSpinner />
      </div>
    );
  }

  if (emailVerified) {
    return (
      <div className="container">
        <div className="d-flex flex-column justify-content-center align-items-center text-center py-5">
          <h2>Email verified</h2>
          <button
            className="btn btn-primary btn-lg mt-3"
            onClick={() => navi("/")}
          >
            Continue
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="container">
      {err && (
        <div
          className="alert alert-danger my-3"
          role="alert"
          aria-live="assertive"
        >
          <p>{err}</p>
          <p className="mt-2 mb-0">
            <Link to="/register" className="alert-link">
              Create a new account
            </Link>
          </p>
        </div>
      )}

      {pendingAccountExists ? (
        <div className="verify-form d-flex flex-column justify-content-center align-items-center text-center">
          <div>
            <h2>{ProjectName}</h2>
            <p>Please check the box and click 'Verify Email' to proceed.</p>

            <div className="my-2">
              <ReCAPTCHA
                sitekey="6LeXa0QqAAAAAOMfVHItB7SWzaKJZCQg0XeM6_d2"
                onChange={(val) => setCapVal(val)}
              />
            </div>

            {!capVal ? (
              <button
                disabled={true}
                className="btn btn-primary btn-lg my-2 verify-button"
              >
                Verify
              </button>
            ) : (
              <button
                onClick={handleVerify}
                className="btn btn-primary btn-lg my-2 verify-button"
              >
                Verify
              </button>
            )}
          </div>
        </div>
      ) : (
        !err && <div>No pending account found.</div>
      )}
    </div>
  );
}
